import { supabase } from "@/integrations/supabase/client";
import { User } from "@/types";

interface SubscriptionData {
  user_id: number;
  subscription_plan_id: number;
}

// Helper function to filter users by their subscription
export const filterUsersBySubscription = async (
  users: User[],
  planFilter: string
): Promise<User[]> => {
  try {
    // If no plan filter is applied, return all users
    if (!planFilter) {
      return users;
    }

    // Fetch active subscriptions from user_subscriptions table
    const { data: subscriptionsData, error: subscriptionsError } =
      await supabase
        .from("user_subscriptions")
        .select("user_id, subscription_plan_id")
        .eq("status", "active");

    if (subscriptionsError) {
      console.error("Error fetching user subscriptions:", subscriptionsError);
      throw subscriptionsError;
    }

    // Create a map of user_id -> plan_id for quick lookups
    const userPlanMap = new Map<number, number>();
    if (subscriptionsData) {
      subscriptionsData.forEach((subscription: SubscriptionData) => {
        userPlanMap.set(
          subscription.user_id,
          subscription.subscription_plan_id
        );
      });
    }

    // If filtering for a specific plan
    if (planFilter !== "none") {
      const planId = parseInt(planFilter, 10);
      // Keep only users that have the specific plan ID
      return users.filter((user) => userPlanMap.get(user.id) === planId);
    }
    // If filtering for "none" plan
    else {
      // Keep only users that don't have any subscription
      return users.filter((user) => !userPlanMap.has(user.id));
    }
  } catch (error) {
    console.error("Error filtering users by subscription:", error);
    throw error;
  }
};
